import React from 'react';

import { Form, InputNumber, Divider } from 'antd';
import { configShort } from '../../../../../common/utils/configFormField';

class Section3 extends React.Component {
  render() {
    const { getFieldDecorator } = this.props.form;
    const { fields, disabledFields } = this.props;
    return (
      <div className="sectionCompensationPeriod">
        <Divider />
        <h1 className="header">
          Компенсации фрахтователю за отказ фрахтовщика от договора за период
        </h1>
        <div className="colsLayout">
          <span className="label">
            Отказ фрахтовщика от договора свыше
            <br />
            хх часов до подачи ТС (КЗ1):
          </span>
          <Form.Item>
            {getFieldDecorator('section3_1', configShort(fields['section3_1']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator('section3_2', configShort(fields['section3_2']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
          <span className="label">
            Отказ фрахтовщика от договора
            <br />
            за хх часа до подачи ТС (КЗ2):
          </span>
          <Form.Item>
            {getFieldDecorator('section3_3', configShort(fields['section3_3']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator('section3_4', configShort(fields['section3_4']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
          <span className="label">
            Отказ фрахтовщика от договора
            <br />
            за хх часа до подачи ТС (КЗ3):
          </span>
          <Form.Item>
            {getFieldDecorator('section3_5', configShort(fields['section3_5']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator('section3_6', configShort(fields['section3_6']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
          <span className="label">
            Отказ фрахтовщика от договора
            <br />
            за хх часа до подачи ТС (КЗ4):
          </span>
          <Form.Item>
            {getFieldDecorator('section3_7', configShort(fields['section3_7']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator('section3_8', configShort(fields['section3_8']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
        </div>
      </div>
    );
  }
}

export default Section3;
